import clsx from "clsx";
import React from "react";
import "./settingsContainerRoot.scss";

interface ISettingsContainerRootProps extends React.ComponentPropsWithoutRef<"div"> { }

export const SettingsContainerRoot = (props: ISettingsContainerRootProps) => {
    return <div {...props} className={clsx("settings-container-root", props.className)} />;
};
